import { Tag } from "@seneca/senekit";

import { Plural } from "features/common/localisation";

import useGetNumberOfUnstudiedSectionsAcrossAssignmentsForCourse from "../../hooks/useGetNumberOfUnstudiedSectionsAcrossAssignmentsForCourse";

export default function AssignmentsSectionsCounter() {
  const numberOfSections =
    useGetNumberOfUnstudiedSectionsAcrossAssignmentsForCourse();

  if (numberOfSections > 0) {
    return (
      <Tag tone="primary" strength="strong" size="xsmall">
        <Plural amount={numberOfSections} item="section" />
      </Tag>
    );
  }

  return null;
}
